import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/var/www/fiction/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
import Schart from "schart.js";
export default {
  props: {
    canvasId: {
      type: String,
      default: "",
      required: true
    },
    options: {
      type: Object,
      required: true
    }
  },
  mounted: function mounted() {
    this.renderChart();
  },
  methods: {
    renderChart: function renderChart() {
      if (!this.checkOptions()) {
        return;
      }

      var opt = _objectSpread({}, this.options);

      new Schart(this.canvasId, opt);
    },
    checkOptions: function checkOptions() {
      var opt = this.options;

      if (!opt.datasets || !opt.datasets.length) {
        return false;
      }

      if (!opt.labels || !opt.labels.length) {
        return false;
      }

      return true;
    }
  },
  watch: {
    options: {
      handler: function handler(newValue, oldValue) {
        this.renderChart();
      },
      deep: true
    }
  }
};